// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import MakerEnhance from "maker-enhance";
var MakerEnhance$1 = {};
function MakerPage(Props) {
  var config = Props.config;
  var elementId = Props.elementId;
  var product = Props.product;
  var user = Belt_Option.flatMap(config.transitiveAccount, function (account) {
    return account.makerPagesSlug;
  });
  var index = "-host-only-" + elementId;
  var index$1 = product !== undefined ? index + "-" + product.id : index;
  if (user !== undefined) {
    return React.createElement(MakerEnhance, {
      user: user,
      index: index$1,
      key: index$1
    });
  } else {
    return null;
  }
}
MakerPage.displayName = "MakerPage";
var make = MakerPage;
export { MakerEnhance$1 as MakerEnhance, make };
/* react Not a pure module */